import React from "react"
import Row from "react-bootstrap/Row"
import { Link } from "gatsby"
import * as BlogStyles from "./../pages/blog.module.scss"

function BlogPostListItem({ edge }) {
  return (
    <Row className={BlogStyles.post} key={edge.node.slug}>
      <div>
        <Link
          to={`/blog/${edge.node.slug}/`}
          style={{ textDecoration: "none" }}
        >
          <h3 className={BlogStyles.title}>{edge.node.title}</h3>
        </Link>
        <p className={BlogStyles.date}>{edge.node.publishedDate}</p>
        <div style={{ marginLeft: "2em" }}>
          {edge.node.category.split(",").map((category, j) => (
            <span
              className={
                j >= 1
                  ? BlogStyles.categoryItemNotFirst
                  : BlogStyles.categoryItem
              }
              key={category}
            >
              #{category}
            </span>
          ))}
        </div>

        <p className={BlogStyles.excerpt}>{edge.node.excerpt}</p>
      </div>
    </Row>
  )
}

export default BlogPostListItem
